import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { CreateTenantRequest } from '../../admin/models/tenant-admin.model';

@Component({
  selector: 'app-create-tenant-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule
  ],
  templateUrl: './create-tenant-dialog.component.html',
  styleUrls: ['./create-tenant-dialog.component.scss']
})
export class CreateTenantDialogComponent {
  private readonly urlRegex = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*';

  private fb = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<CreateTenantDialogComponent>);

  form = this.fb.group({
    name: ['', [Validators.required, Validators.minLength(2)]],
    plan_type: ['free', [Validators.required]],
    host_url: ['', [Validators.required, Validators.minLength(2)], Validators.pattern(this.urlRegex)],
    initial_admin_name: ['', [Validators.required, Validators.minLength(2)]],
    initial_admin_email: ['', [Validators.required, Validators.email]]
  });

  cancel() {
    this.dialogRef.close(null);
  }

  submit() {
    if (this.form.invalid) return;
    const payload = this.form.value as CreateTenantRequest;
    this.dialogRef.close(payload);
  }
}
